import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { useSubheader } from "../../../../_metronic/layout";
import { ReceiptRetrieval } from "./ReceiptRetrieval";


export const ReceiptRetrievalManagement = () => {

  const subheader = useSubheader();
  subheader.setTitle("Receipt Retrieval");
  
  return (
    <>
      <div className="row">
        <div className="col-12">
          <Switch>
            <Redirect
              from="/receipt-retrieval"
              exact={true}
              to="/receipt-retrieval/find-my-receipt"
            />
            <Route
              path="/receipt-retrieval/find-my-receipt"
              component={ReceiptRetrieval}
            />
          </Switch>
        </div>
      </div>
    </>
  );
};
